import { FormattedMessage, useIntl } from "react-intl";
import { ReactComponent as PackageIcon } from "assets/images/iconsV2/package.svg";
import { ReactComponent as PlusIcon } from "assets/images/iconsV2/plus.svg";
import Button from "components/v2/Button/Button";

interface EmptyParcelAccountStateProps {
  onClickAddAccount: () => void;
}

export default function EmptyParcelAccountState({ onClickAddAccount }: EmptyParcelAccountStateProps) {
  const intl = useIntl();
  return (
    <div className="d-flex justify-content-center align-items-center flex-column py-11xl">
      <div className="package-icon">
        <PackageIcon />
      </div>

      <div className="text-secondary-v2 text-md font-semibold mb-xs">
        <FormattedMessage id="settings.parcelAccounts.noAccountsAddedYet" defaultMessage="No accounts added yet" />
      </div>
      <div className="text-tertiary text-sm font-regular mb-3xl text-center" style={{ maxWidth: 352 }}>
        <FormattedMessage
          id="settings.parcelAccounts.noAccountsAddedYet.subtitle"
          defaultMessage="Add one now and start managing your parcels integration and configurations"
        />
      </div>

      <Button
        label={intl.formatMessage({
          id: "settings.parcelAccounts.addAccount",
          defaultMessage: "Add account",
        })}
        iconLeft={<PlusIcon />}
        size="lg"
        onClick={onClickAddAccount}
      />
    </div>
  );
}
